/* RESPONSIBLE TEAM: team-ai-agent-2 */
import { attr } from '@ember-data/model';
import { fragment } from 'ember-data-model-fragments/attributes';
import Fragment from 'ember-data-model-fragments/fragment';
import type CustomBotData from 'embercom/models/operator/custom-bots/custom-bot-data';

export default class AdditionalData extends Fragment {
  @attr('string') declare title: string;
  @attr('string') declare description: string;
  @attr('array') declare targetChannels: string[];
  @attr('array') declare preferredDevices: string[];
  // @ts-ignore defaultValue is supported by fragment
  // https://github.com/adopted-ember-addons/ember-data-model-fragments?tab=readme-ov-file#default-values
  @fragment('operator/custom-bots/custom-bot-data', { defaultValue: {} })
  declare customBotData: CustomBotData;
}
